import defaultSettings from '@/settings'
import { generateTitle } from '@/utils/i18n'

const title = defaultSettings.title || 'Vue Admin Template'

export default function getPageTitle(pageTitle) {
  console.log(pageTitle)
  if (pageTitle) {
    return `${transTitle} - ${title}`
  }
  return `${title}`
}
